import { render, staticRenderFns } from "./TemplateLibrary.view.vue?vue&type=template&id=656a1f12&scoped=true&"
import script from "./TemplateLibrary.view.vue?vue&type=script&lang=js&"
export * from "./TemplateLibrary.view.vue?vue&type=script&lang=js&"
import style0 from "./TemplateLibrary.view.vue?vue&type=style&index=0&id=656a1f12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656a1f12",
  null
  
)

export default component.exports